import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function AboutSection() {
  const { ref, visible } = useScrollReveal();
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="about" className="py-20 bg-white">
      <div ref={ref} className={`mx-auto px-4 md:px-6 max-w-6xl transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-7'}`}>
        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="flex-1">
            <p className="text-sm font-semibold tracking-wide text-olive-500 uppercase mb-2">
              Meet Your Guide
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-olive-800 mb-5">
              Hi, I'm Carol 👋
            </h2>
            <p className="text-olive-700 leading-relaxed mb-4">
              I'm a busy mom and paralegal who discovered that creating more
              freedom for my family didn't mean sacrificing my values or
              working around the clock.
            </p>
            <p className="text-olive-700 leading-relaxed mb-5">
              After years of balancing work, family, and a growing desire to live
              more naturally, I found two paths that changed everything:
            </p>
            <ul className="space-y-3 mb-5">
              <li className="flex items-start gap-3 text-olive-700">
                <span className="mt-1 w-5 h-5 flex items-center justify-center shrink-0 text-olive-500">
                  <i className="fas fa-check-circle text-sm"></i>
                </span>
                A way to earn extra income by sharing products families already
                need
              </li>
              <li className="flex items-start gap-3 text-olive-700">
                <span className="mt-1 w-5 h-5 flex items-center justify-center shrink-0 text-olive-500">
                  <i className="fas fa-check-circle text-sm"></i>
                </span>
                Simple green swaps that make our homes healthier and safer
              </li>
            </ul>
            <p className="text-olive-700 leading-relaxed mb-6">
              Now, I help other families do the same — without the stress,
              without the overwhelm, and without compromising what matters most.
            </p>
            <button
              onClick={() => handleScroll("#contact")}
              className="inline-flex items-center gap-2 font-semibold text-olive-600 hover:text-olive-800 transition-colors cursor-pointer"
            >
              Let's Connect
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="fas fa-arrow-right text-sm"></i>
              </span>
            </button>
          </div>
          <div className="flex-shrink-0">
            <div className="w-72 h-80 rounded-2xl overflow-hidden ring-4 ring-olive-100 shadow-[18px_-20px_55px_-10px_rgba(107,128,74,0.4)]">
              <img
                alt="Carol Berry — Wellness & Freedom"
                className="w-full h-full object-cover object-top"
                src="https://static.readdy.ai/image/7cfefdb5ac845d9253969aa3e814c221/64822497ecced71a646ebffe2a6e3c8d.png"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}